import pluralize from 'pluralize';
import { goToChainsPage, goToInsightsPage } from 'router/go-to-routes';

import type { Complex, Place } from '@placer-ui/types';
import { FilterInsights } from 'core/entities/filter';
import { Filter } from '@placer-ui/types';
import { goToMarketsPage, GoToMarketsPageParams } from 'router/go-to-routes/go-to-markets-page';
import { getDefaultPropertyPathname } from 'router/utils/get-default-property-pathname';
import { OVERVIEW_REPORT_NAME } from 'utils/navigation/navigation-consts';
import { getFeatureFlags } from 'core/flow-control';

export const openPropertyReport = (
    property: Place,
    newTab = true,
    section = getDefaultPropertyPathname(),
    filters?: Filter[] | FilterInsights[],
) => {
    const { id, type } = property;
    goToInsightsPage({
        id,
        collection: pluralize(type),
        newTab,
        useWindow: true,
        section,
        filters,
    });
};

export const openChainsReport = (chainId: string | null | undefined, newTab = true) => {
    if (chainId) {
        goToChainsPage({
            entities: [{ id: chainId }],
            newTab,
        });
    }
};

export type OpenMarketReportParams = Pick<
    GoToMarketsPageParams,
    'competitor' | 'section' | 'newTab'
> & {
    marketEntity: Complex;
};

export const openMarketReport = ({
    marketEntity,
    section = OVERVIEW_REPORT_NAME,
    newTab = true,
    competitor,
}: OpenMarketReportParams) => {
    const { id, type, purchased } = marketEntity;
    const { enable_market_unpurchased_demographics_only_ff } = getFeatureFlags();

    goToMarketsPage({
        id,
        collection: pluralize(type),
        section:
            enable_market_unpurchased_demographics_only_ff && purchased === false ? 'demographics' : section,
        newTab,
        competitor,
    });
};
